import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import BigIcon from 'UI/atoms/BigIcon';
import CardContent from 'UI/atoms/CardContent';
import Subtitle from 'UI/atoms/Subtitle';
import Title from 'UI/atoms/Title';

import warning from 'assets/img/icon/warning.png';

const CompanyError = () => {
  const { t } = useTranslation();

  return (
    <CardContent sm={{ span: 10, offset: 1 }}>
      <BigIcon src={warning} />
      <Title>{t('company.error.title')}</Title>
      <Row>
        <Col xs={12} sm={{ span: 10, offset: 1 }}>
          <Subtitle>
            {t('company.error.subtitle')}
          </Subtitle>
        </Col>
      </Row>
    </CardContent>
  );
};

export default CompanyError;
